import { dispLoading, removeLoading } from "./display_modals";

// form がsubmit された時にdispLoadingを発火
var form_buttons = document.querySelectorAll('form');
// loading を表示しないフォームのid を登録
var exclude_ids = ['card_info-form']

form_buttons.forEach((element) => {
    if (!exclude_ids.includes(element.id)) {
        element.onsubmit = (e) => {
            // console.log(e);
            dispLoading('Loading');
        }
    }
});

document.onload = (e) => {
    removeLoading();
}